import { notification as AntNotification } from 'antd';

type TNotification = 'success' | 'info' | 'warning' | 'error';

export const notification = (type: TNotification, message: string): void => {
    AntNotification[type]({
        message,
    });
};
